import React from 'react'
import { useLocation } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { LoadScript } from '@react-google-maps/api'
import theme from './theme/index.js'
import Header from './components/layout/Header/index.js'
import Sidebar from './components/layout/Sidebar/index.js'
import AppRoutes from './routes/routes.js'
import useAppSelector from './state/redux/hooks/useAppSelector.js'
import useAutoLogout from './features/auth/hooks/useAutoLogout.js'
import MobileWarningModal from './components/common/MobileWarningModal/MobileWarningModal.jsx'

const App = () => {
  const auth = useAppSelector(state => state.auth.isAuthenticated)
  const location = useLocation()
  // useAutoLogout()

  // List of routes that shouldn't show sidebar/header
  const authPages = ['/login', '/register', '/forgot-password']
  const isAuthPage = authPages.includes(location.pathname)
  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <ThemeProvider theme={theme}>
        <div className="App">
          {!isAuthPage && auth && <Header />}
          <div className="App-content">
            {!isAuthPage && auth && <Sidebar />}
            <div className="App-main">
              <AppRoutes />
            </div>
          </div>
          <MobileWarningModal />
        </div>
      </ThemeProvider>
    </LoadScript>
  )
}

export default App
